import { CartUpdateEvent } from '@theme/events';

/**
 * Handles quick-add clicks from the cart-drawer cross-sell row
 * (snippets/cart-drawer-upsell.liquid). Adds the clicked variant to the
 * cart via the Ajax Cart API, then dispatches a CartUpdateEvent so the
 * theme's existing cart-items-component / cart-icon listeners re-render
 * themselves in place — the same pattern used by free-gift-auto-add.js.
 */
(function () {
  var SOURCE_ID = 'cart-drawer-upsell';

  /** @param {MouseEvent} event */
  function handleClick(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var button = target.closest('[data-cart-drawer-upsell-add]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.disabled = true;
    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to add item to cart');
        return response.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CartUpdateEvent(cart, SOURCE_ID, {
            itemCount: cart.item_count,
            source: SOURCE_ID,
          })
        );

        button.classList.remove('is-loading');
        button.classList.add('is-added');

        setTimeout(function () {
          button.classList.remove('is-added');
          button.disabled = false;
        }, 1500);
      })
      .catch(function (error) {
        // eslint-disable-next-line no-console
        console.error('[cart-drawer-upsell]', error);
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', handleClick);
})();
